import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import TrustCounters from "@/components/sections/TrustCounters";
import InstantDemoWidget from "@/components/sections/InstantDemoWidget";
import ProblemSolution from "@/components/sections/ProblemSolution";
import HowItWorks from "@/components/sections/HowItWorks";
import EnterpriseCTA from "@/components/sections/EnterpriseCTA";
import InsurerLogoWall from "@/components/InsurerLogoWall";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Testimonials from "@/components/sections/Testimonials";
import MobileApp from "@/components/sections/MobileApp";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Home() {
  const { user } = useAuth();

  // Capture ?ref=CODE — persist in localStorage; if user is logged in, apply now.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (!ref) return;
    localStorage.setItem("miclaim_ref", ref.toUpperCase());
    if (user) {
      api.post("/referrals/apply", { code: ref.toUpperCase() })
        .then((r) => { toast.success(r.data.message || "Referral applied"); localStorage.removeItem("miclaim_ref"); })
        .catch(() => {});
    }
  }, [user]);

  return (
    <div data-testid="home-page">
      <Hero />
      <TrustCounters />
      <InstantDemoWidget />
      <InsurerLogoWall />
      <ProblemSolution />
      <HowItWorks />
      <WhyChooseUs />
      <EnterpriseCTA />
      <Testimonials />
      <MobileApp />
    </div>
  );
}
